import { useEffect, useState } from 'react'

// Debounces the search input into the gallery query key so typing does not fire a
// request per keystroke. An empty value applies at once: "Clear Filters" resets the
// search synchronously, and debouncing that reset would hold the (empty) filtered
// results on screen for the delay before the default page returns.
function useDebouncedValue(value, delay) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    if (!value) {
      setDebounced(value)
      return undefined
    }
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}

export default useDebouncedValue
